import DataSource from "devextreme/data/data_source";
import { fetchDataSource } from "../../finance/finance_helper";

import {
  applyQueryStringFiltersPlugin,
  columnChooserPlugin,
  columnFiltersPlugin,
  columnsPlugin,
  dynamicHeightPlugin,
  exportPlugin,
  localStoragePlugin,
  rowGroupPlugin,
  searchPlugin,
  storedViewsPlugin,
  summaryPlugin,
} from "../plugins";

/**
 * @param {Object} options
 * @param {String} options.columnOverrides
 * @param {String} options.visibleColumnByDefault
 * @param {import("../plugins/export").ExportPluginOptions} options.export
 * @param {String} options.dataSourceURL
 * @param {String} options.dataSourceTransformer
 * @param {String} options.storageKey
 * @param {import("../plugins/summary").SummaryPluginOptions} options.summary
 *
 * @returns {import("../datagrid").Pack}
 */
export function financePack(options) {
  return [
    applyQueryStringFiltersPlugin({ visibleColumnByDefault: options.visibleColumnByDefault }),
    columnChooserPlugin({ resetColumnsKey: options.storageKey }),
    columnFiltersPlugin(),
    columnsPlugin({ columnOverrides: options.columnOverrides }),
    dynamicHeightPlugin(),
    exportPlugin(options.export),
    financeDataSourcePlugin(options),
    financeFilterFormPlugin(options.storageKey),
    financeStylePlugin(),
    localStoragePlugin(options.storageKey),
    rowGroupPlugin(),
    searchPlugin(),
    storedViewsPlugin(),
    summaryPlugin(options.summary),
  ];
}

function financeDataSourcePlugin(options) {
  return {
    options: {
      dataSource: new DataSource({
        load() {
          return fetchDataSource(options.dataSourceURL, ["start_date", "end_date", "overlap_mode"], options.dataSourceTransformer);
        },
      }),
      paging: {
        enabled: true,
        pageSize: 200,
      },
      pager: {
        showPageSizeSelector: true,
        allowedPageSizes: [100, 200, 500],
        showInfo: true,
        showNavigationButtons: true,
      },
      scrolling: {
        mode: "standard",
      },
    },
  };
}

/**
 * Set the dates in local storage when the filter form is submitted, to preserve the dates interval when navigating away.
 * If storageKey is null, no date filters is set. It's used when there are query params in url with Petronille.
 * @param {string|null} storageKey - local storage key for the finance tabular
 */
function financeFilterFormPlugin(storageKey) {
  const $filterForm = document.querySelector(".js-datagrid-filter-form");
  $filterForm.addEventListener("submit", (_event) => {
    const formData = new FormData($filterForm);

    // The date filters are stored in local storage so that, when moving out
    // of the finance analysis pages and coming back, the date values are still
    // the same as before.
    localStorage.setItem("finance-datagrid-start-date", formData.get("start_date"));
    localStorage.setItem("finance-datagrid-end-date", formData.get("end_date"));
  });

  if (storageKey !== null) {
    const storedStartDate = localStorage.getItem("finance-datagrid-start-date");
    const storedEndDate = localStorage.getItem("finance-datagrid-end-date");

    if (storedStartDate !== null) {
      $filterForm["start_date"].value = storedStartDate;
    }

    if (storedEndDate !== null) {
      $filterForm["end_date"].value = storedEndDate;
    }
  }
  return {};
}

function financeStylePlugin() {
  return {
    options: {
      allowColumnReordering: true,
      columnAutoWidth: true,
      showColumnLines: false,
      rowAlternationEnabled: false,
    },
  };
}
